import { AxiosResponseHeaders } from 'axios';
import { SweepOrdersResponseDTO } from '../entities';

const sweepOrdersDTOToSweepOrdersAdapter = (data: SweepOrdersResponseDTO, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { sweepOrdersDTOToSweepOrdersAdapter };
